import { gql } from "@apollo/client";
import moment from "moment";

const GET_DOCUMENTOS_RI = gql`
    query documentosEvolucionesAsistencial($idEvaluacion: Int!) {
        documentosEvolucionesAsistencial(idEvaluacion: $idEvaluacion) {
            success,
            error,
            valorEsperado {
                idArchivo,
                idTipoArchivoDocumento,
                tipoArchivo,
                titulo,
                datos,
                fechaAlta,
                figuraProfesional,
                profesional,
                referencia,
                nroTalonario
            }
        }
    }
`;

export default GET_DOCUMENTOS_RI;

export const adaptDocumento = (documento) => {
  return {
    idArchivo: documento?.idArchivo,
    idTipoArchivoDocumento: documento?.idTipoArchivoDocumento,
    tipoArchivo: documento?.tipoArchivo,
    titulo: documento?.titulo,
    datos: documento?.datos,
    figuraProfesional: documento?.figuraProfesional,
    profesional: documento?.profesional,
    referencia: documento?.referencia,
    nroTalonario: documento?.nroTalonario,
    fechaAlta: moment(documento?.fechaAlta).format('DD/MM/yyyy')
  };
};

export const adaptDocumentosArray = (documentos) => {
  return structuredClone(documentos?.documentosEvolucionesAsistencial?.valorEsperado)?.
  map((documento) => adaptDocumento(documento));
};